import React, { useContext, useState, useEffect } from "react";
import { Col, Row, Button, Card } from "react-bootstrap";
import Statics from "../Statics";
import { useParams } from "react-router-dom";
import ComponentContext from "../Context";
import DocumentMeta from "react-document-meta";
import HeaderBanner from "../Components/HeaderBanner";
import Kargah from "../Images/kargah.png";

const REGISTRATION_STATUS = {
  PENDING: 1,
  COMPLETED: 2,
  CANCELED: 3,
};

const WORKSHOP_STATUS = {
  PENDING: 2,
  ACTIVE: 3,
  COMPLETED: 5,
  CANCELED: 6,
};

export default () => {
  const { workshop_id } = useParams();
  const context = useContext(ComponentContext);
  const [loading_state, set_loading_state] = useState(Statics.NOT_LOADED);
  const [person, set_person] = useState({});

  const page_meta = {
    language: "fa",
    copyright: "پژوهیار",
    description: "نرم‌افزار استناددهی",
    title: "پرداخت | کارگاه",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "پژوهیار",
      },
    },
  };

  const body = `به منظور فراگیریِ بهتر پژوهیار، دوره‌های آموزشی در سه سطح در نظر گرفته شده است. برای
      درخواست کارگاه و کلاس آموزشی از طریق فرم تربیت‌مدرس، فرم سازمانی و فرم عمومی ثبت نام فرمایید.`;

  useEffect(() => {
    if (loading_state === Statics.NOT_LOADED) {
      getRegisterationData();
    }
    // eslint-disable-next-line
  }, [loading_state]);

  const getRegisterationData = () => {
    set_loading_state(Statics.LOADING);
    context.ApiDriver.showRegisteredWorkshop(
      { id: workshop_id },
      data => {
        set_person(data);
        set_loading_state(Statics.LOADED);
      },
      error => {
        set_loading_state(Statics.CAUSED_ERROR);
      },
    );
  };

  const cancelRegisteration = () => {
    set_loading_state(Statics.LOADING);
    context.ApiDriver.cancelRegisteration(
      { id: workshop_id },
      data => {
        set_loading_state(Statics.LOADED);
        context.notification("ثبت نام با موفقیت لغو شد.", "success");
        window.location = "/workshop";
      },
      error => {
        set_loading_state(Statics.CAUSED_ERROR);
      },
    );
  };

  const generatePaylink = () => {
    context.ApiDriver.generatePaymentLink(
      { id: workshop_id },
      data => {
        window.location = data.link;
      },
      error => {},
    );
  };

  const renderWorkshopSessions = () => {
    if (!person.workshop?.meetings?.data?.length) return null;

    return person.workshop.meetings.data.map((session, index) => (
      <Row key={index}>
        <p>
          جلسه {index + 1}: {"\u00A0"}
          <label>
            {`${session.start_date.year}/${session.start_date.month}/${
              session.start_date.day
            } ${session.start_date.hour}:${session.start_date.minute
              .toString()
              .padStart(2, "0")}`}
          </label>
          {"\u00A0"}تا{"\u00A0"}
          <label>
            {`${session.finish_date.hour}:${session.finish_date.minute
              .toString()
              .padStart(2, "0")}`}
          </label>
        </p>
      </Row>
    ));
  };

  const renderPersonalInfo = () => (
    <>
      <Row>
        <Col>
          <Row>
            <label>نام:</label>
            <label>{person.first_name}</label>
          </Row>
        </Col>
        <Col>
          <Row>
            <label>نام‌خانوادگی:</label>
            <label>{person.last_name}</label>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <label>تاریخ تولد:</label>
            <label>{person.birth_date}</label>
          </Row>
        </Col>
        <Col>
          <Row>
            <label>کدملی:</label>
            <label>{person.id_number}</label>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <label>رشته:</label>
            <label>{person.field}</label>
          </Row>
        </Col>
        <Col>
          <Row>
            <label>مقطع:</label>
            <label>{person.grade}</label>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <label>دانشگاه:</label>
            <label>{person.university}</label>
          </Row>
        </Col>
        <Col>
          <Row>
            <label>شغل:</label>
            <label>{person.job}</label>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <label>آدرس:</label>
          <label>{person.address}</label>
        </Col>
      </Row>
    </>
  );

  const renderActionButtons = () => {
    if (!person.status || !person.workshop?.status) return null;

    const regStatus = person.status.code;
    const wsStatus = person.workshop.status.code;
console.log(regStatus);
console.log(wsStatus);
 
    if (regStatus === REGISTRATION_STATUS.CANCELED) {
      return (
        <Row className="pt-3 pb-3 justify-content-center">
          <Button variant="secondary" disabled>
            شما از این کارگاه انصراف داده‌اید
          </Button>
        </Row>
      );
    }

     
    if (regStatus === REGISTRATION_STATUS.COMPLETED) {
      return (
        <Row className="pt-3 pb-3 justify-content-center">
          <Button variant="success" disabled>
            پرداخت با موفقیت انجام شد. منتظر برگزاری کارگاه باشید.
          </Button>
        </Row>
      );
    }

     
    if (
      regStatus === REGISTRATION_STATUS.PENDING &&
      [WORKSHOP_STATUS.ACTIVE, WORKSHOP_STATUS.COMPLETED].includes(wsStatus)
    ) {
      return (
        <Row className="pt-3 pb-3 justify-content-around">
          <Button variant="success" onClick={generatePaylink}>
            پرداخت
          </Button>
          <Button variant="danger" onClick={cancelRegisteration}>
            انصراف
          </Button>
        </Row>
      );
    }

     
    if (
      regStatus === REGISTRATION_STATUS.PENDING &&
      wsStatus === WORKSHOP_STATUS.PENDING
    ) {
      return (
        <>
          <Row className="pt-3 pb-3 justify-content-center">
            <Button variant="info" disabled>
              ثبت‌نام شما انجام شد. در صورت تشکیل کارگاه با شما تماس می‌گیریم.
            </Button>
          </Row>
          <Row className="pt-3 pb-3 justify-content-center">
            <Button variant="danger" onClick={cancelRegisteration}>
              انصراف
            </Button>
          </Row>
        </>
      );
    }

    if (wsStatus === WORKSHOP_STATUS.CANCELED) {
      return "کارگاه لغو شده است.";
    }

    return null;
  };

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner body={body} image={Kargah} header_color="#E5E1DA" />

      {loading_state === Statics.LOADED && (
        <Row className="mx-0 justify-content-center pt-5">
          <Col md={8} className="text-right">
            <Row>
              <Card>
                <Card.Header>اطلاعات کارگاه</Card.Header>
                <Card.Body>
                  <Row>
                    <Col>
                      <Row>
                        <label>نام کارگاه:</label>
                        {"\u00A0"}
                        <label>{person.workshop.title}</label>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>توضیحات:</label>
                        {"\u00A0"}
                        <label>{person.workshop.description}</label>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>قیمت:</label>
                        {"\u00A0"}
                        <label>
                          {person.workshop.offered_fee.toLocaleString()} ریال
                        </label>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>نوع کارگاه:</label>
                        {"\u00A0"}
                        <label>{person.workshop.type.text}</label>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>{renderWorkshopSessions()}</Col>
                  </Row>
                </Card.Body>
              </Card>
            </Row>

            <Row className="pt-5">
              <Card>
                <Card.Header>اطلاعات فردی</Card.Header>
                <Card.Body>{renderPersonalInfo()}</Card.Body>
              </Card>
            </Row>

            {renderActionButtons()}
          </Col>
        </Row>
      )}

      {loading_state === Statics.LOADING && (
        <div className="text-center py-5">در حال بارگیری اطلاعات...</div>
      )}

      {loading_state === Statics.CAUSED_ERROR && (
        <div className="text-center py-5 text-danger">
          خطا در دریافت اطلاعات. لطفاً دوباره تلاش کنید.
        </div>
      )}
    </DocumentMeta>
  );
};
